export enum ConstructionPeriod {
  BEFORE_1949 = "BEFORE_1949",
  BETWEEN_1949_AND_1997 = "BETWEEN_1949_AND_1997",
  AFTER_1997 = "AFTER_1997",
}

export enum ConstructionPeriodLabel {
  BEFORE_1949 = "< 1949",
  BETWEEN_1949_AND_1997 = "1949 - 1997",
  AFTER_1997 = "> 1997",
}

export enum FormType {
  CREATE,
  UPDATE,
}

export enum FileTypeValue {
  erpExpress = "ERPE",
  incomingInventory = "EDLE",
  outgoingInventory = "EDLS",
  outgoingIncomingInventory = "EDLSE",
  diagnostic = "DIAG",
  rentalVisit = "VILO",
  preVisitAdvice = "PVCO",
  virtualVisit = "VIVI",
  picture = "PICT",
}

export enum GridType {
  dwelling = "dwelling",
  service = "service",
  building = "building",
}

export enum Rating {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  F = "F",
  G = "G",
}

export enum OperatingStatus {
  F = "Fonctionnel",
  NF = "Non Fonctionnel",
  NV = "Non vérifié",
  ABS = "Absent",
  RAL = "Remis a l'occupant",
}

export enum OperatingStatusKey {
  F = "F",
  NF = "NF",
  NV = "NV",
  ABS = "ABS",
  RAL = "RAL",
}

export enum OperatingStatusKeys {
  F = "F",
  NF = "NF",
  NV = "NV",
}

export enum Status {
  new = "Neuf",
  good = "Bon état",
  average = "État moyen",
  poor = "Dégradé",
  oof = "HS",
}

export enum Permissions {
  SUPER_ADMIN_ACTION = "SUPER_ADMIN_ACTION",
  // AGENCY
  AGENCY_GET = "AGENCY_GET",
  AGENCY_CREATE = "AGENCY_CREATE",
  AGENCY_UPDATE = "AGENCY_UPDATE",
  AGENCY_DELETE = "AGENCY_DELETE",
  // AGENDA
  AGENDA_GET = "AGENDA_GET",
  // BUILDING/DWELLING
  BUILDING_DWELLING_CREATE = "BUILDING_DWELLING_CREATE",
  BUILDING_DWELLING_UPDATE = "BUILDING_DWELLING_UPDATE",
  BUILDING_DWELLING_GET = "BUILDING_DWELLING_GET",
  BUILDING_DWELLING_GET_LIST = "BUILDING_DWELLING_GET_LIST",
  // DASHBOARD
  DASHBOARD_GET = "DASHBOARD_GET",
  // GROUP
  GROUP_GET = "GROUP_GET",
  GROUP_CREATE = "GROUP_CREATE",
  GROUP_UPDATE = "GROUP_UPDATE",
  GROUP_DELETE = "GROUP_DELETE",
  // MOBILE
  MOBILE_ACCESS = "MOBILE_ACCESS",
  // SERVICE REPORT REFERENTIAL
  SERVICE_REPORT_REFERENTIAL_GET_BY_TYPE = "SERVICE_REPORT_REFERENTIAL_GET_BY_TYPE",
  SERVICE_REPORT_REFERENTIAL_LIST = "SERVICE_REPORT_REFERENTIAL_LIST",
  // SERVICE REPORT
  SERVICE_REPORT_GET = "SERVICE_REPORT_GET",
  SERVICE_REPORT_CREATE = "SERVICE_REPORT_CREATE",
  SERVICE_REPORT_UPLOAD_FILES = "SERVICE_REPORT_UPLOAD_FILES",
  SERVICE_REPORT_UPDATE = "SERVICE_REPORT_UPDATE",
  // SERVICE
  SERVICE_CREATE = "SERVICE_CREATE",
  SERVICE_UPDATE = "SERVICE_UPDATE",
  SERVICE_UPDATE_LITE = "SERVICE_UPDATE_LITE",
  SERVICE_GET = "SERVICE_GET",
  SERVICE_GET_LIST = "SERVICE_GET_LIST",
  // SERVICE WORKFLOW
  SERVICE_WORKFLOW_UPDATE = "SERVICE_WORKFLOW_UPDATE",
  SERVICE_WORKFLOW_SET_USER = "SERVICE_WORKFLOW_SET_USER",
  // TEAM
  TEAM_GET = "TEAM_GET",
  TEAM_CREATE = "TEAM_CREATE",
  TEAM_UPDATE = "TEAM_UPDATE",
  TEAM_DELETE = "TEAM_DELETE",
  // USER
  USER_GET = "USER_GET",
  USER_CREATE = "USER_CREATE",
  USER_UPDATE = "USER_UPDATE",
  USER_DELETE = "USER_DELETE",
}


export enum BusinessServiceType {
  RENTAL_MANAGEMENT = "rental_management",
  CONDOMINIUM_MANAGEMENT = "condominium_management",
  PROPERTY_SALES = "property_sales",
  RENOVATION_DEVELOPMENT = "renovation_development",
  ERP_EXPRESS = "erp_express"
}
